"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createStoresApi = void 0;

var _react = require("@reduxjs/toolkit/query/react");

var _objects = require("../utilities/objects");

var createStoresApi = function createStoresApi(baseApiPath) {
  return (0, _react.createApi)({
    reducerPath: 'storesApi',
    baseQuery: (0, _react.fetchBaseQuery)({
      baseUrl: "".concat(baseApiPath, "/pos/"),
      prepareHeaders: function prepareHeaders(headers, _ref) {
        var _getState, _getState$user;

        var getState = _ref.getState;
        var token = (_getState = getState()) === null || _getState === void 0 ? void 0 : (_getState$user = _getState.user) === null || _getState$user === void 0 ? void 0 : _getState$user.accessToken;

        if (token) {
          headers.set('Authorization', "Bearer ".concat(token));
        }

        return headers;
      }
    }),
    endpoints: function endpoints(builder) {
      return {
        getStore: builder.query({
          query: function query(storeId) {
            return "stores/".concat(storeId);
          },
          transformResponse: function transformResponse(response) {
            return (0, _objects.toCamelCase)(response);
          }
        }),
        getStores: builder.query({
          // TODO: change when https://github.com/asicsdigital/microservice-users-api/pull/400 is merged
          // query: (searchQuery) => `stores?search=${searchQuery}`,
          query: function query(clientId) {
            return "stores?clientId=".concat(clientId);
          },
          transformResponse: function transformResponse(response) {
            return (0, _objects.toCamelCase)(response);
          }
        }),
        syncCBR: builder.mutation({
          query: function query(params) {
            return {
              body: params,
              credentials: 'include',
              method: 'POST',
              url: 'cbr'
            };
          },
          transformResponse: function transformResponse(response) {
            return (0, _objects.toCamelCase)(response);
          }
        }),
        syncClutch: builder.mutation({
          query: function query(params) {
            return {
              body: params,
              credentials: 'include',
              method: 'POST',
              url: 'clutch'
            };
          },
          transformResponse: function transformResponse(response) {
            return (0, _objects.toCamelCase)(response);
          }
        })
      };
    }
  });
};

exports.createStoresApi = createStoresApi;